var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarBlocked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12703_61460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12703_61460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 25C9.53236 25.0162 5.01459 20.5089 5.00004 15.0111C4.98548 9.5296 9.48955 5.01631 14.9884 5.00004C20.4693 4.98378 24.9828 9.4868 25 14.988C25.0171 20.467 20.5113 24.9837 15.0116 25ZM8.511 20.0834C12.385 16.2156 16.2427 12.3624 20.0978 8.51343C17.1322 6.02564 12.2154 6.0068 9.07433 9.23168C5.95205 12.436 6.11813 17.2883 8.51186 20.0834H8.511ZM9.86111 21.4403C12.8558 23.9941 17.978 24.048 21.1534 20.5235C24.2089 17.1334 23.6601 12.3067 21.4273 9.87803C17.5791 13.7253 13.7291 17.5725 9.86025 21.4395L9.86111 21.4403Z",
    fill: "#B0B0B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlocked);
export default __webpack_public_path__ + "static/media/calendar_blocked.6d2bfb04bd671fd81fbc4a002e99cc29.svg";
export { ForwardRef as ReactComponent };